
<mat-card-content>
    <p>
        One of the most powerful exercises one can do to take control of their diet is to write down everything they eat. 
        This concept is what drives applications like <strong>My Fitness Pal</strong> or <strong>My Macros +</strong>. 
        The main goal of this application is no different than others like it, the thing that sets it apart is the 
        fact that it takes a hands off approach to your data. 
    </p>
    <p>
        Data for this application is stored locally in your browser, that means none of it ever leaves your computer.
        This approach ensures that you are in control of your data, no one else can intercept, log, track or sell 
        the information. The big draw back here is that your data isn't available on multiple devices. For instance, if you 
        choose to start tracking your information in your home computer, you won't be able to access
        that information from your cell phone. Currently you can export your information from this site to a file, which could 
        be uploaded into any other browser. The hope is to eventually integrate some cloud storage options like 
        <strong>Dropbox</strong> or <strong>Google Drive</strong>.
    </p>
    <p>
        
    </p>
</mat-card-content>